import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import ProviderOrdersTable from './components/ProviderOrdersTable';
import SignatureManagement from './components/SignatureManagement';
import { useQuery } from "@apollo/client";
import clientGraphql from "../../common/apollo-graphql";
import { FETCH_USER_PROVIDER } from "./gql/query";

export default function ViewProvider() {
  const { data, loading } = useQuery(FETCH_USER_PROVIDER, {
    client: clientGraphql,
    fetchPolicy: "network-only",
  });

  const [signature, setSignature] = useState(null);
  const [autoApproved, setAutoApproved] = useState(false);

  useEffect(() => {
    setSignature(data?.userProvider?.signature?.fileurl || null);
    setAutoApproved(data?.userProvider?.auto_approved || false);
  }, [data]);

  return (
    <Box p={3}>
      <SignatureManagement
        signature={signature}
        onSignatureChange={setSignature}
        autoApproved={autoApproved}
        loading={loading}
      />
      <Box mt={4}>
        <ProviderOrdersTable signature={signature} />
      </Box>
    </Box>
  );
}
